import * as $helpers from './_helpers'

export class uniformBoxHeights {
    private listElements:JQuery;
    private prevWindowWidth:number = -1;
    private prevPrefix:string = null;
    private resizeFunction:any = function () {};
    private options:any;
    private optionDefaults:any = {
        listElementsSelector: null,
        sizesToSkip: []
    };

    constructor(options:any) {
        var self = this;
        self.options = $.extend(true, {}, self.optionDefaults, options);

        console.log("uniformBoxHeights ctor");

        self.resizeFunction = _.debounce(function () {
            var currentWindowWidth: number = $(window).width();

            if (currentWindowWidth != self.prevWindowWidth) {
                self.setHeights();
                self.prevWindowWidth = currentWindowWidth;
            }
        }, 250);

        $(window).on("resize", function () { self.resizeFunction(); });

        self.setHeights(true);
    }

    public setHeights(forceUpdate:boolean = false) : void {
        var self = this;
        
        var prefix = $helpers.currentPageSize();

        console.log("uniformBoxHeights setHeights");

        //if (prefix != self.prevPrefix || forceUpdate === true || prefix == "xs" || prefix == "xxs") {
            self.listElements = $(self.options.listElementsSelector);

            console.log(self.listElements);

            self.resetHeights();

            if ($.inArray(prefix, self.options.sizesToSkip) == -1) {
                var maxHeight = -1;
                self.listElements.each(function () {
                    var thisOuterHeight = $(this).outerHeight();
                    if (thisOuterHeight === null) thisOuterHeight = $(this).height();
                    if (thisOuterHeight > maxHeight) maxHeight = thisOuterHeight;
                });
                self.listElements.css("height", maxHeight + "px");
            }

            self.prevPrefix = prefix;
        //}
    }

    public resetHeights() {
        var self = this;

        self.listElements.css("height", "");
        self.listElements.css("min-height", "inherit");
    }
}